module.exports = __webpack_public_path__ + "static/media/repeat.d6e31641.svg";